var module = angular.module('tradersyard');

module.run([
    'graph-api-client',
    'graph-tooltip-factory',
    function ($api, $factory) {
        $api.factory.tooltip = $factory;
    },
]);

module.factory('graph-tooltip-factory', ['graph-api-client', graphTooltipFactory]);

function graphTooltipFactory(client) {
    function Tooltips(entry, id, term) {
        if (term === undefined) term = 'profile';

        if (entry === 'user') {
            entry = undefined;
        } else {
            term = undefined;
        }

        this.read = function (options) {
            return client.get([entry, id, term], options);
        };
    }

    return {
        entry: function (entry, id, term) {
            return new Tooltips(entry, id, term);
        },
    };
}
